/**
 * Una celda de tabla que trae varias líneas se entrega como ARRAY, no como
 * texto de corrido.
 *
 * `jspdf-autotable` acepta `string[]` como contenido de celda y pinta una línea
 * por elemento (su contrato: `CellInput = null | string | string[] | number |
 * boolean | CellDef`). Antes se aplastaba todo con el normalizador del
 * exportador, que colapsa `\s+` en un espacio: un recorrido de dos carreteras
 * salía en el PDF como «82+800 234+000» en una sola línea, sin poder decir qué
 * kilómetro es de qué vía — justo lo que la tabla de pantalla sí distingue.
 *
 * El colapso se sigue aplicando DENTRO de cada línea, que es para lo que estaba.
 *
 * Vive aparte de `table-to-pdf` para poder probarlo sin arrastrar jsPDF, que en
 * el entorno de test pide `TextEncoder` y no tiene nada que ver con esto.
 */

/** Texto de una celda: una línea, o varias. */
export type CellText = string | string[];

/** Colapsa el espacio invisible y sobrante de UNA línea. */
export function normalizeLine(text: string | null | undefined): string {
  if (text === null || text === undefined) return '';
  return text
    .replace(/ /g, ' ') // espacio duro → espacio normal
    .replace(/​/g, '') // espacio de ancho cero
    .replace(/‌/g, '') // no-juntador de ancho cero
    .replace(/‍/g, '') // juntador de ancho cero
    .replace(/﻿/g, '') // BOM
    .replace(/\s+/g, ' ') // varios espacios → uno
    .trim();
}

export function cellLines(text: string | null | undefined): CellText {
  const raw = text ?? '';
  if (!raw.includes('\n')) return normalizeLine(raw);
  const lineas = raw
    .split('\n')
    .map((linea) => normalizeLine(linea))
    .filter((linea) => linea !== '');
  return lineas.length > 1 ? lineas : (lineas[0] ?? '');
}

export default cellLines;
